export default __webpack_public_path__ + "static/media/february.21332fa2.jpg";